var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 251.79 41.8",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#Unbenannter_Verlauf_6);}.cls-2{fill:url(#Unbenannter_Verlauf_6-2);}.cls-3{fill:url(#Unbenannter_Verlauf_6-3);}.cls-4{fill:url(#Unbenannter_Verlauf_6-4);}.cls-5{fill:#fff;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Unbenannter_Verlauf_6",
    x1: 76.41,
    y1: 20.79,
    x2: 245.2,
    y2: 18.25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#415a77"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0d1b2a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Unbenannter_Verlauf_6-2",
    x1: 76.41,
    y1: 20.36,
    x2: 245.19,
    y2: 17.83,
    xlinkHref: "#Unbenannter_Verlauf_6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Unbenannter_Verlauf_6-3",
    x1: 76.44,
    y1: 22.22,
    x2: 245.22,
    y2: 19.68,
    xlinkHref: "#Unbenannter_Verlauf_6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Unbenannter_Verlauf_6-4",
    x1: 76.5,
    y1: 26.39,
    x2: 245.28,
    y2: 23.85,
    xlinkHref: "#Unbenannter_Verlauf_6"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ebene_2",
    "data-name": "Ebene 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ebene_1-2",
    "data-name": "Ebene 1"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "63.96 0 89.18 0 73.97 41.8 48.75 41.8 63.96 0"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "35.73 0 60.95 0 45.74 41.8 20.52 41.8 35.73 0"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "92.21 0 251.79 0 236.58 41.8 76.99 41.8 92.21 0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M12.81,12.83H28l-10.55,29H0L9.66,15.27A3.36,3.36,0,0,1,12.81,12.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M46.33,12.67H41l-1.63,4.16c-.44,1.13.22,1.69,2,1.69q3.48,0,5.13,1.73t.58,4.85L45,30.53a5.46,5.46,0,0,1-2.24,2.55,6.14,6.14,0,0,1-3.32,1H31.13a3,3,0,0,1-2.51-1,2.47,2.47,0,0,1-.23-2.55l2.07-5.31h5.63l-1.58,4h5.32l1.63-4.15c.44-1.13-.22-1.7-2-1.7q-3.48,0-5.13-1.72t-.58-4.85l2.13-5.43a5.37,5.37,0,0,1,2.24-2.55,6.07,6.07,0,0,1,3.32-1h8.27a3,3,0,0,1,2.51,1,2.44,2.44,0,0,1,.24,2.55l-2.08,5.28H44.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M65.55,23.4l-4.2,10.72H55.73L66,7.8h5.62l-4.2,10.72h2.16L77.31,7.8H83L73.61,21,72.7,34.12H67l.72-10.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M108.42,25.71h-4l3.91-10.77c.43-1.16,1-2.45,1.56-3.85h-.1a25.36,25.36,0,0,1-1.44,2.38L99.69,25.71H96.37l.12-12.11a22,22,0,0,1,.35-2.51h-.12c-.53,1.77-1,3.33-1.53,4.66l-3.62,10H87.91l6.55-18h5.94l-.21,10.67A13.32,13.32,0,0,1,99.9,21H100c.59-1,1.15-1.86,1.66-2.6l7.55-10.64H115Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M123.3,25.71H112.51l6.55-18h10.38l-1.2,3.3h-6.33l-1.45,4h5.88l-1.2,3.28h-5.88l-1.5,4.12h6.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M144.17,11H139l-5.35,14.7h-4.06L135,11h-5.1l1.2-3.3h14.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M157.07,25.71h-4.42l.18-4h-6.4l-2.72,4h-4.4l13.1-18h4.81Zm-4-7.12.27-6.05a7.74,7.74,0,0,1,.29-1.62h-.1a9.87,9.87,0,0,1-.88,1.57l-4.18,6.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M170,25.71H159.31l6.55-18h4.06l-5.36,14.71h6.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M183.17,25.71H172.45l6.55-18h4.06L177.7,22.42h6.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M185.59,25.71l6.55-18h6.55q3,0,4.23,1.11a2.65,2.65,0,0,1,.49,3.11,5.84,5.84,0,0,1-1.92,2.55A8.09,8.09,0,0,1,198.42,16v0A3.27,3.27,0,0,1,201,17.46a3.22,3.22,0,0,1,.1,2.88,7.67,7.67,0,0,1-3.2,3.92,9.86,9.86,0,0,1-5.36,1.45ZM192.46,18l-1.73,4.74h2.2a4.54,4.54,0,0,0,2.44-.65,3.45,3.45,0,0,0,1.44-1.78,1.57,1.57,0,0,0-.17-1.7,2.55,2.55,0,0,0-2-.61Zm2.65-7.28L193.55,15h1.79a4,4,0,0,0,2.19-.6,3.32,3.32,0,0,0,1.34-1.68q.72-2-2.25-2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M217.89,25.71h-4.42l.18-4h-6.4l-2.72,4h-4.4l13.1-18H218Zm-4-7.12.27-6.05a7.74,7.74,0,0,1,.29-1.62h-.1a9.87,9.87,0,0,1-.88,1.57l-4.18,6.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M237.64,17.91q-3,8.11-10.5,8.11-7.33,0-4.45-7.92l3.78-10.39h4.07l-3.8,10.44q-1.59,4.37,1.82,4.37t4.89-4.22L237.3,7.71h4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M93.42,27.67l-2.35,6.45h-.71l1.56-4.3L88,34h0l-.86-4.2-1.57,4.3h-.71l2.35-6.45h.08l1.19,5,4.86-5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M95.17,28.49l-.73,2h2.61l-.26.71H94.18l-.8,2.2h3l-.26.71H92.4l2.31-6.33h3.72l-.25.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M99.56,27.79h.72L98,34.12h-.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M99.32,33l.7-.4a1.19,1.19,0,0,0,1.28.9,2,2,0,0,0,1.9-1.07c.26-.71-.53-1.05-1.23-1.36s-1.4-.68-1-1.66a2.84,2.84,0,0,1,2.61-1.7c.94,0,1.39.51,1.4,1.13l-.67.37a.89.89,0,0,0-1-.8,1.83,1.83,0,0,0-1.63,1c-.22.62.4.84,1.1,1.15s1.55.83,1.18,1.85a3.09,3.09,0,0,1-2.89,1.8C100,34.21,99.38,33.67,99.32,33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M110.21,28.5h-1.84l-2.05,5.62h-.72l2.05-5.62h-1.84l.25-.71h4.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M111.79,28.49l-.73,2h2.61l-.26.71H110.8l-.8,2.2h3l-.26.71H109l2.31-6.33h3.73l-.26.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M117.56,34.12l-.88-2.47H115.5l-.9,2.47h-.72l2.3-6.33h1.88a1.4,1.4,0,0,1,1.4,2,3,3,0,0,1-2,1.76l1,2.55Zm-.66-3.07a2.09,2.09,0,0,0,1.83-1.26.9.9,0,0,0-.9-1.29h-1.19l-.92,2.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M124.23,32.19a3.07,3.07,0,0,1-2.71,1.93h-2.35l2.31-6.33h1.73c1.06,0,1.55.75,1.25,1.58a1.85,1.85,0,0,1-1.26,1.19A1.1,1.1,0,0,1,124.23,32.19Zm-.68,0c.21-.59-.16-1.11-1-1.1H121l-.87,2.38h1.58A2.08,2.08,0,0,0,123.55,32.14Zm-1.61-3.66-.7,1.92h1.05a1.51,1.51,0,0,0,1.46-.95c.2-.54-.15-1-.76-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M127.16,28.49l-.73,2H129l-.26.71h-2.61l-.8,2.2h3l-.26.71h-3.73l2.31-6.33h3.72l-.25.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M135.23,28.5h-1.84l-2,5.62h-.71l2-5.62h-1.84l.25-.71h4.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M137.72,34.12l-.87-2.47h-1.19l-.9,2.47h-.71l2.3-6.33h1.87a1.41,1.41,0,0,1,1.41,2,3,3,0,0,1-2,1.76l1,2.55Zm-.66-3.07a2.09,2.09,0,0,0,1.84-1.26A.9.9,0,0,0,138,28.5h-1.18l-.93,2.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M141.64,27.79h.72l-2.31,6.33h-.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M144.15,28.49l-.73,2H146l-.26.71h-2.61l-.8,2.2h3l-.26.71h-3.72l2.3-6.33h3.73l-.26.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M151.31,32.19a3.08,3.08,0,0,1-2.72,1.93h-2.35l2.31-6.33h1.73c1.06,0,1.55.75,1.25,1.58a1.86,1.86,0,0,1-1.25,1.19A1.11,1.11,0,0,1,151.31,32.19Zm-.69,0c.22-.59-.16-1.11-1-1.1h-1.54l-.87,2.38h1.58A2.08,2.08,0,0,0,150.62,32.14ZM149,28.48l-.7,1.92h1.06a1.53,1.53,0,0,0,1.46-.95c.19-.54-.16-1-.76-1Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.00e8f57b853c682fdf87b5cecd89b806.svg";
export { ForwardRef as ReactComponent };